import superagent from "superagent";
import { BASE_API_URL } from "../APIs/APIs";
import axios from "axios";
import {
  loginInProgress,
  loginFetchedToken,
  loginFetchedRefreshToken,
  loginFetchedUserInfo,
  loginIsDone,
} from "./loginAsync";

export default function requestMiddleware() {
  return ({ dispatch, getState }) => (next) => (action) => {
    if (action.type === "EVENTS.INVALID_TOKEN") {
      let theStore = getState();
      if (theStore.auth && theStore.auth.token && theStore.auth.refreshToken) {
        if (!theStore.auth.pendingRefreshingToken) {
          dispatch({ type: "EVENTS.REFRESHING_TOKEN" });
          console.log(`before superagent"`);
          superagent
            .post(
              `${BASE_API_URL}api/raybodSCM/v1/account/getRefreshToken?token=${theStore.auth.token}&refreshToken=${theStore.auth.refreshToken}`
            )
            .end((err, { body } = {}) => {
              if (body.status === 200) {
                console.log(`body.status === 200"`);
                if (body.data.succeeded) {
                  //localStorage.removeItem("persist:scmroot");
                  dispatch(loginFetchedToken(body.data.result.token));
                  dispatch(
                    loginFetchedRefreshToken(body.data.result.refreshToken)
                  );
                  dispatch(loginIsDone(true));
                  dispatch({ type: "EVENTS.TOKEN_REFRESHED" });
                  axios.defaults.headers.common[
                    "Authorization"
                  ] = `Bearer ${body.data.result.token}`;
                } else {
                  localStorage.removeItem("persist:scmroot");
                  window.location = "/";
                }
              }
            });
        }
      }
    } else {
      // if (buffer.length > 20) {
      //   //remove all items but keep the last 20 which forms the buffer
      //   buffer.splice(0, buffer.length - 20);
      // }
      return next(action);
    }
  };
}
